var feedbackBtn = document.querySelectorAll(".feedback__action--btn"),
  submitVerboseFeedback = document.getElementById("submitVerboseFeedback"),
  feedbackOptions = document.getElementById("feedback-options"),
  feedbackThankYou = document.getElementById("feedback-thank-you"),
  feedbackError = document.getElementById("feedback-error"),
  negativeFeedback = document.getElementById("negative-feedback");

for (var i = 0; i < feedbackBtn.length; i++) {
  feedbackBtn[i].addEventListener(
    "click",
    function(evt) {
      evt.preventDefault();

      var btnVal = this.dataset.value; 
      feedbackOptions.classList.add("hide");

      if (btnVal === "yes") {
        //Webtracker Event
        window.hasOwnProperty("WebEventTracker")
          ? WebEventTracker.logEvent(EDS.webEvents, "guideFeedbackGiven", {
              is_useful: "Yes",
            })
          : "";

        feedbackThankYou.classList.add("show");
      } else if (btnVal === "no") {
        //Webtracker Event
        window.hasOwnProperty("WebEventTracker")
          ? WebEventTracker.logEvent(EDS.webEvents, "guideFeedbackGiven", {
              is_useful: "No",
            })
          : "";

        negativeFeedback.classList.add("show");
      }
    },
    false
  );
}

//Submit button
if (submitVerboseFeedback) {
  submitVerboseFeedback.addEventListener(
    "click",
    function(evt) {
      evt.preventDefault();

      var additionalInfo = document.getElementById("additional-info");
      feedbackError.innerHTML = "";
      
      if (additionalInfo.value.trim().length > 0) {
        //Webtracker Event
        window.hasOwnProperty("WebEventTracker")
          ? WebEventTracker.logEvent(EDS.webEvents, "guideVerboseFeedbackGiven", {
              is_useful: "No",
              additional_info: additionalInfo.value.trim()
            })
          : "";

        negativeFeedback.classList.remove("show");
        feedbackThankYou.classList.add("show");
      } else {
        feedbackError.innerHTML = "Please write a message";
      }
    },
    false
  );
}
